import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Slide } from '@material-ui/core';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

export const DialogSlide = ({ title, content: Content, open, handleClose, handleSave }) => {

  return (
		<Dialog
			open={open}
			TransitionComponent={Transition}
			keepMounted
			onClose={handleClose}
			aria-labelledby="alert-dialog-slide-title"
			aria-describedby="alert-dialog-slide-description"
            fullWidth
            maxWidth="md"
		>
			<DialogTitle id="alert-dialog-slide-title">
				{ title }
			</DialogTitle>
			<DialogContent>
                <Content />
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} color="primary">
					Odustani
				</Button>
				<Button onClick={handleSave} color="primary">
					Sačuvaj
				</Button>
			</DialogActions>
		</Dialog>
	);
}

DialogSlide.propTypes = {
    title: PropTypes.string,
    content: PropTypes.any,
    open: PropTypes.bool,
    handleClose: PropTypes.func,
    handleSave: PropTypes.func
}

export default DialogSlide;
